// @flow
import type { InsurancePassengers } from "./types"

const INSURANCE_STORAGE_KEY = "insurancePassenger"

export function saveInsurancePassengers(passengers: InsurancePassengers): void {
  sessionStorage.setItem(INSURANCE_STORAGE_KEY, JSON.stringify(passengers))
}

export function loadInsurancePassengers(): InsurancePassengers {
  try {
    const storageItem = sessionStorage.getItem(INSURANCE_STORAGE_KEY)

    if (storageItem) {
      return JSON.parse(storageItem)
    }
  } catch (error) {
    // eslint-disable-line no-empty
  }

  return {}
}
